// The caller's Company fulfillment standing (GET /api/companies/fulfillment-status).
//
// Whether the Company has a fulfillment agreement on file (or one in flight),
// and which finished goods / kits it already fulfils — offered as a picker in
// the configurator's fulfillment section so a customer can point at an existing
// SKU instead of describing one. The backend resolves the Company server-side
// from the verified token and returns a customer-safe subset (no cost data).
//
// Not pricing data, so R4 would permit a short cache, but the section holds
// none: every mount revalidates against Nexus. A browser reload starts from an
// empty cache.
//
// `refreshFromWarehouse` is the SKU picker's "check the warehouse for new items"
// click and nothing else — Nexus pulls the Company's new ArgoWMS items before the
// standing is read. Never send it on load, open, keystroke or timer.

import type { CompanyFulfillmentStanding } from 'shared';

import { api } from './client.js';

export async function getCompanyFulfillmentStatus(
  opts: { refreshFromWarehouse?: boolean } = {},
): Promise<CompanyFulfillmentStanding> {
  const res = await api.get<CompanyFulfillmentStanding>('/companies/fulfillment-status', {
    params: opts.refreshFromWarehouse === true ? { refresh_from_warehouse: 'true' } : {},
  });
  return res.data;
}
